// eslint-disable-next-line no-unused-vars, @typescript-eslint/no-unused-vars
import { uetTagSelectorStyles, convertToLocalStyle } from '@bingads-webui-campaign-react/common-styles';

export const getImportOptionsFormStyle = ({ palette = {} } = {}) => ({
  '& .advanced-import-options-form': {
    marginBottom: 15,

    '& .form-horizontal': {
      '& .error': {
        color: '#A80000',
      },
      '& .col-sm-4, & .col-sm-8': {
        paddingLeft: 28,
        width: '100%',

        '& .import-options-indented-section': {
          '& .input': {
            width: '66.7%',
          },
        },
      },

      '& .form-group': {
        marginLeft: 0,
        marginRight: 0,
        marginBottom: 0,
      },

      '& .control-label': {
        textAlign: 'left',
      },

      '& .checkbox': {
        paddingTop: 0,

        '& >label': {
          display: 'inline-block',
        },
      },

      '& .scheduling-form': {
        '& .control-label': {
          paddingLeft: 0,

          '& .spritedimage': {
            marginRight: 8,
          },
        },
      },

      '& .form-label-container.col-sm-4': {
        float: 'unset',
      },

      '& .form-input-container[data-property="ImportAccountUrlOptions"]': {
        '& .template-subtext': {
          marginLeft: 8,

          '& .bold': {
            fontWeight: 600,
            display: 'inline-block',

            '& .import-options-link': {
              fontWeight: 400,
            },
          },

          '& .tracking-template-url': {
            display: 'inline-block',
            paddingLeft: 4,
          },
        },
      },

      '& .form-input-container[data-property="EnableAutoCurrencyConversion"]': {
        '& .currency-description': {
          marginLeft: 8,
        },

        '& .currency-title': {
          marginLeft: 8,

          '& .bold': {
            fontWeight: 600,
            display: 'inline-block',
          },

          '& .currency-value': {
            display: 'inline-block',
            paddingLeft: 4,
          },
        },
      },

      '& .form-group[data-property="AssociatedUETTagId"] > .col-sm-8': {
        paddingLeft: 56,
      },

      '& .uet-tag-selector': {
        width: 'unset',
        '& select': {
          marginLeft: -14,
          width: '66.7%',
        },
        '& .row.row-gap': {
          marginBottom: 8,
        },
      },

      '& .form-input-container[data-property="ImportNewEntities"], & .form-input-container[data-property="UpdateEntityPreferences"]': {
        '& .checkbox': {
          '& label + span > a.helpbutton': {
            marginLeft: '-6px',
          },

          '& .toggle-link': {
            paddingLeft: 10,
          },
        },

        '& .advanced-options': {
          '& .advanced-options-form, & .col-sm-4, & .col-sm-8': {
            paddingLeft: 28,
          },
        },
      },

      '& .import-options-indented-section.numeric-adjustment': {
        paddingLeft: 28,
        paddingBottom: 4,

        '& select.form-control': {
          width: 135,
        },

        '& input.form-control': {
          width: 66,
        },

        '& .inline-label-text': {
          height: 32,
          lineHeight: '32px',
          width: 'unset',
        },
      },

      '& .form-validation-container': {
        '& ul.help-block.error': {
          listStyle: 'none',
          paddingLeft: 28,
        },
      },

      '& .form-group.scheduling-form': {
        '& .control-label': {
          '& a': {
            display: 'block',

            '&:focus, &:hover': {
              border: 'none',
              textDecoration: 'none',
              backgroundColor: '#F3F2F1',
            },
          },
        },
      },
    },
  },

  '& .error-panel': {
    maxWidth: 900,

    '& #ImportErrorTable': {
      marginBottom: 15,

      '& table': {
        width: '100%',
        color: palette.neutralPrimary,
        tableLayout: 'fixed',

        '& .grid-header-row': {
          '& .grid-header-cell': {
            fontWeight: 600,
            padding: '8px 10px',
            borderTop: '2px solid #81868B',
            borderBottom: '2px solid #81868B',

            '& .grid-header-text': {
              color: palette.neutralPrimary,
              wordBreak: 'break-word',
            },
          },

          '& .grid-header-cell:nth-child(2), .grid-header-cell:nth-child(3)': {
            width: '30%',
          },
        },

        '& tbody': {
          '& .grid-row': {
            '& .grid-cell': {
              padding: '8px 10px',

              '& .grid-content-container': {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              },
            },
          },
        },

        '& th, td': {
          borderRight: `1px solid ${palette.neutralLight}`,
          borderBottom: `1px solid ${palette.neutralLight}`,

          '&:last-child': {
            borderRight: 0,
          },
        },

        '& .iconba-ErrorBadge, .iconba-ErrorBadge + span': {
          verticalAlign: 'middle',
        },
      },
    },
  },

  ...convertToLocalStyle(uetTagSelectorStyles()),
});
